import { render, staticRenderFns } from "./EditLabelSet.vue?vue&type=template&id=53e7c6d4&scoped=true"
import script from "./EditLabelSet.vue?vue&type=script&lang=js"
export * from "./EditLabelSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e7c6d4",
  null
  
)

export default component.exports